import {
  ADVISORY_STATUS_BADGE_COLOR,
  ADVISORY_STATUS_NAMES,
} from '../../../constants/visitsConstants';
import {
  AdvisoryDeliveryTime,
  AdvisoryLead,
  AdvisoryLeadStatus,
} from '../models/dashboardModels';

// Mismas etiquetas que el form público de asesorías
// (propi-web-nextjs/src/components/page/asesoria/constants/options.ts) —
// mantener sincronizado si cambian ahí.
export const ADVISORY_GOAL_NAMES: Record<string, string> = {
  comprar_vivir: 'Comprar para vivir',
  comprar_invertir: 'Comprar para invertir',
  explorando: 'Estoy explorando opciones',
};

export const ADVISORY_PROPERTY_TYPE_NAMES: Record<string, string> = {
  casa: 'Casa',
  apartamento: 'Apartamento',
};

export const ADVISORY_DELIVERY_TIME_NAMES: Record<string, string> = {
  inmediata: 'Inmediata',
  planos: 'Planos',
};

// Split de línea de negocio — mismo que la auto-asignación de SDR en
// user-service (AdvisoryService.getNextAssignedSdrId): `inmediata` → SDR_SALES
// (Secondary), `planos` → SDR_PRESALES (Presales). `indiferente` nunca se
// persiste (se normaliza a `planos` antes de guardar, ver
// AdvisoryService.saveLeadAndNotify) — `delivery_time` acá sólo puede ser
// `inmediata` | `planos`.
export const ADVISORY_BUSINESS_LINE_NAMES: Record<AdvisoryDeliveryTime, string> = {
  inmediata: 'Secondary',
  planos: 'Presales',
};

export const ADVISORY_MONTHLY_BUDGET_NAMES: Record<string, string> = {
  menos_500: 'Menos de $500',
  '500_1000': '$500 - $1,000',
  '1000_1500': '$1,000 - $1,500',
  '1500_2500': '$1,500 - $2,500',
  mas_2500: 'Más de $2,500',
  no_se: 'Aún no lo sé',
};

export const ADVISORY_CONTACT_SCHEDULE_NAMES: Record<string, string> = {
  manana: 'Mañana (8:00 AM - 12:00 PM)',
  tarde: 'Tarde (1:00PM - 5:00PM)',
  indiferente: 'Indiferente',
};

export const getAdvisoryStatusLabel = (status: string): string =>
  ADVISORY_STATUS_NAMES[status] ?? status;

export const getAdvisoryStatusBadgeColor = (status: string): string =>
  ADVISORY_STATUS_BADGE_COLOR[status] ?? 'secondary';

export interface AdvisoryStatusCounts {
  pending_approval: number;
  scheduled: number;
  rescheduled: number;
  cancelled: number;
  finished: number;
  total: number;
}

// Contador simple por status, calculado client-side sobre los items ya
// cargados (página actual) — no hay endpoint de métricas para Advisory.
export const toAdvisoryStatusCounts = (
  leads: AdvisoryLead[],
): AdvisoryStatusCounts => {
  const counts: Record<AdvisoryLeadStatus, number> = {
    pending_approval: 0,
    scheduled: 0,
    rescheduled: 0,
    cancelled: 0,
    finished: 0,
  };
  leads.forEach((lead) => {
    counts[lead.status] = (counts[lead.status] ?? 0) + 1;
  });
  return { ...counts, total: leads.length };
};

// class-validator devuelve `message` como array cuando falla más de una
// validación a la vez — el resto de errores (negocio, duplicados, 4xx/5xx
// del backend) lo devuelve como string.
export const getAdvisoryErrorMessage = (data: any, fallback: string): string => {
  const message = Array.isArray(data?.message)
    ? data.message.join(', ')
    : data?.message;
  return message || fallback;
};
